import Model from 'flarum/common/Model';
export default class PollTranslation extends Model {
  pollId() {
    return String(Model.attribute('pollId').call(this));
  }
  language() {
    return Model.attribute('language').call(this);
  }
  question() {
    return Model.attribute('question').call(this);
  }
  subtitle() {
    return Model.attribute('subtitle').call(this);
  }
  imageAlt() {
    return Model.attribute('imageAlt').call(this);
  }
  provider() {
    return Model.attribute('provider').call(this);
  }
  sourceLanguage() {
    return Model.attribute('sourceLanguage').call(this);
  }
  updatedAt() {
    return Model.attribute('updatedAt', Model.transformDate).call(this);
  }
  options() {
    return Model.hasMany('options').call(this);
  }

  /**
   * Translated answer for a poll option id, if the response included one.
   */
  answerFor(optionId) {
    const options = this.options();
    if (!options || !optionId) return null;
    return options.find(option => option?.optionId() === optionId)?.answer() ?? null;
  }
}
flarum.reg.add('fof-translate', 'common/models/PollTranslation', PollTranslation);